import React from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow,
  IconButton,
  Tooltip,
  TextField
} from '@mui/material';
import {
  Edit as EditIcon,
  CheckCircle as CheckIcon,
  Close as CloseIcon
} from '@mui/icons-material';

const QualificationDetails = ({ data, editable, values, onFieldChange, editingField, onEditField, onCancelEdit, onSaveField }) => {
  if (!data || typeof data !== 'object') return null;
  
  const fields = [
    "QUALIFICATION TITLE",
    "SAQA QUAL ID",
    "QUALIFICATION TYPE",
    "FIELD",
    "SUBFIELD",
    "MINIMUM CREDITS",
    "NQF LEVEL",
    "LAST DATE FOR ENROLMENT",
    "LAST DATE FOR ACHIEVEMENT",
    "PURPOSE OF THE QUALIFICATION",
    "LEARNER OUTCOMES",
    "RATIONALE FOR THE QUALIFICATION"
  ];
  
  return (
    <Paper sx={{ p: 2, mb: 2 }}>
      <Table size="small">
        <TableBody>
          {fields.map(field => (
            <TableRow key={field}>
              <TableCell sx={{ fontWeight: 'bold', width: 220 }}>{field}</TableCell>
              <TableCell sx={{ whiteSpace: 'pre-line', position: 'relative' }}>
                {editable && editingField === field ? (
                  <Box display="flex" alignItems="center">
                    <TextField
                      value={values[field] || ''}
                      onChange={e => onFieldChange(field, e.target.value)}
                      size="small"
                      multiline
                      minRows={2}
                      fullWidth
                      sx={{ mr: 1 }}
                    />
                    <Tooltip title="Save">
                      <IconButton onClick={() => onSaveField(field)} size="small">
                        <CheckIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Cancel">
                      <IconButton onClick={onCancelEdit} size="small">
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </Box>
                ) : (
                  <Box display="flex" alignItems="center">
                    <Box flex={1} sx={{ whiteSpace: 'pre-line' }}>
                      {values[field] || ''}
                    </Box>
                    {editable && (
                      <Tooltip title="Edit">
                        <IconButton onClick={() => onEditField(field)} size="small">
                          <EditIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    )}
                  </Box>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default QualificationDetails; 